<template>
	<Modal v-model="show" title="账号信息" :width="60" @on-visible-change="onShowChange"  @on-cancel="cancal">
		<Spin v-if="$globalSpin" size="large" fix></Spin>
		<Form ref="userExternalCustomerForm" :model="userExternalCustomerForm" :rules="ruleValidate"
			label-position="top" class="small-form">
			<Row :gutter="24">
				<Col span="6">
				<FormItem label="会员号" prop="userName">
					<Input v-model="userExternalCustomerForm.userName"
						:readonly="formEditMode === FORM_EDIT_MODE_MODIFY"></Input>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="申请人" prop="userExternalCustomerName">
					<Input v-model="userExternalCustomerForm.userExternalCustomerName"></Input>
				</FormItem>
				</Col>
				<Col span="6" v-show="formEditMode === FORM_EDIT_MODE_MODIFY">
				<FormItem label="申请日期" prop="userExternalCustomerCreateAt">
					<Input readonly
						v-model="userExternalCustomerForm.userExternalCustomerCreateAt.substring(0, 10)"></Input>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="生产种类" prop="userExternalCustomerProductionType">
					<Input v-model="userExternalCustomerForm.userExternalCustomerProductionType"></Input>
				</FormItem>
				</Col>

			</Row>

			<Row :gutter="24">
				<Col span="6">
				<FormItem label="手机号" prop="userExternalCustomerPhone">
					<Input v-model="userExternalCustomerForm.userExternalCustomerPhone"></Input>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="职务" prop="post">
					<Select v-model="userExternalCustomerForm.post" filterable>
						<Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.label }}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="场名" prop="userExternalCustomerFarmName">
					<Input v-model="userExternalCustomerForm.userExternalCustomerFarmName"></Input>
				</FormItem>
				</Col>

				<Col span="6">
				<div class="areaunit">
					<FormItem label="温室面积" prop="userExternalCustomerGreenhouseArea">
						<div class="areaunit">
							<Input v-model="userExternalCustomerForm.userExternalCustomerGreenhouseArea"
								type="number"></Input>
						</div>
					</FormItem>
					<FormItem label="温室面积单位" prop="unit">
						<Select v-model="userExternalCustomerForm.unit" filterable class="area" clearable>
							<Option v-for="item in unitList" :key="item.value" :value="item.value">{{ item.label }}
							</Option>
						</Select>
					</FormItem>
				</div>
				</Col>

			</Row>
			<Row :gutter="24">
				<Col span="6">
				<FormItem label="省份" prop="userExternalCustomerProvinceUuid">
					<Select v-model="userExternalCustomerForm.userExternalCustomerProvinceUuid" filterable>
						<Option v-for="item in provinceOptions" :key="item.regionUuid" :value="item.regionUuid">{{
							item.regionName }}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="城市" prop="userExternalCustomerCityUuid">
					<Select v-model="userExternalCustomerForm.userExternalCustomerCityUuid" filterable>
						<Option v-for="item in cityOptions" :key="item.regionUuid" :value="item.regionUuid">{{
							item.regionName }}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="区域" prop="userExternalCustomerDistUuid">
					<Select v-model="userExternalCustomerForm.userExternalCustomerDistUuid" filterable>
						<Option v-for="item in distOptions" :key="item.regionUuid" :value="item.regionUuid">{{
							item.regionName }}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="花场地址" prop="userExternalCustomerFullAddress">
					<Input v-model="userExternalCustomerForm.userExternalCustomerFullAddress" type="textarea"></Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="16">
				<Col span="6" v-if="$checkAccessArray(['B', 'D', 'I', 'S', 'A'])">
				<FormItem label="客户经理" prop="userExternalCustomerRelateCustomerManagerUuid">
					<Select v-model="userExternalCustomerForm.userExternalCustomerRelateCustomerManagerUuid" filterable @on-change = "onChangeCustomerManager">
						<Option v-for="(item,index) in userCustomerManagerSource" :key="index"
							:value="item.userCustomerManagerLoginUuid">{{ item.userCustomerManagerName }}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6" v-if="$checkAccessArray(['B', 'D', 'I', 'S', 'A'])">
				<FormItem label="默认客户经理" prop="defaultCustomerManagerUuid">
					<Select v-model="userExternalCustomerForm.defaultCustomerManagerUuid" filterable>
						<Option v-for="(item,index) in userCustomerManagerSource" :key="index"
							:value="item.userCustomerManagerLoginUuid">{{ item.userCustomerManagerName }}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6" v-if="$checkAccessArray(['B', 'D', 'I', 'S', 'A'])">
				<FormItem label="客户类型" prop="accountType">
					<Select v-model="userExternalCustomerForm.accountType" filterable >
						<Option v-for="item in accountTypeList" :key="item"
							:value="item">{{item}}</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="收货地点">
					<div>
						<RadioGroup v-model="userExternalCustomerForm.memberDeliveryAddressSelectType" type="button"
							@on-change="onSelectType">
							<Radio :key="1" :label="1">花场地址
							</Radio>
							<Radio :key="2" :label="2">提货站
							</Radio>
							<Radio :key="3" :label="3">其它站点
							</Radio>
						</RadioGroup>
					</div>
				</FormItem>
				</Col>
				<Col span="6">
					<FormItem
					v-show="showDistribution"
					label="自提站"
					prop="distributionStationName"
					>
					<Select
						v-model="userExternalCustomerForm.userExternalCustomerDefaultDistributionStationUuid"
						filterable
						clearable
					>
						<Option
						v-for="(item, index) in stationList"
						:value="item.distributionStationUuid"
						:key="item.distributionStationUuid"
						>
						{{ item.distributionStationName }}
						</Option>
					</Select>
				</FormItem>

				</Col>
				<Col span="6">
				<FormItem v-show="showFullAddress" label="收货地址" prop="userExternalCustomerReceiptFullAddress"
					type="textarea">
					<Input v-model="userExternalCustomerForm.userExternalCustomerReceiptFullAddress"
						type="textarea"></Input>
				</FormItem>
				</Col>

			</Row>
			<Row :gutter="16">
				<Col span="6" v-if="$checkAccessArray(['G', 'S'])">
				<FormItem label="审批">
					<div>
						<RadioGroup v-model="userExternalCustomerForm.userExternalCustomerApproval" type="button"
							@on-change="onshowDescribe">
							<Radio v-for="item in approvalSource" :key="item.val" :label="item.val">{{ item.label }}
							</Radio>
						</RadioGroup>
					</div>
				</FormItem>
				</Col>
			</Row>
			<!-- <Row>
				<Col>
					<FormItem span="6" label="黑名单状态">
					<div>
						<RadioGroup v-model="isBlacklisted" type="button">
						<Radio :label="true" disabled>黑名单</Radio>
						<Radio :label="false" disabled>非黑名单</Radio>
						</RadioGroup>
					</div>
					</FormItem>
				</Col>
			</Row> -->
			<Row :gutter="24">
				<Col span="12" v-if="$checkAccessArray(['G', 'S'])">
				<div v-show="showDescribe">
					<FormItem label="不通过原因" prop="approvalFailReason">
						<Input v-model="userExternalCustomerForm.approvalFailReason" type="textarea" :rows="4"
							placeholder="请输入审批不通过的原因" />
					</FormItem>
				</div>
				</Col>
			</Row>
			<Row :gutter="16" v-show="userExternalCustomerForm.userExternalCustomerApproval == 1">
				<Col v-if="formEditMode === FORM_EDIT_MODE_CREATE" span="6">
				<FormItem label="密码">
					<Input v-model="password" type="password"></Input>
				</FormItem>
				</Col>
				<Col v-if="formEditMode === FORM_EDIT_MODE_CREATE" span="6">
				<FormItem label="密码确认">
					<Input v-model="passwordConfirm" type="password"></Input>
				</FormItem>
				</Col>
			</Row>
		</Form>

		<div>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">客户评价</span>
					</div>
					<div class="right-bar">
						<Button size="small" class="btns" shape="circle" type="success"
							icon="ios-add-circle-outline" @click="addEreviews">新增</Button>

					</div>
				</div>
				</Col>
			</Row>
			<Row :gutter="16">
				<Col span="24">
				<stand-pagination-table :columns="reviewsMainTable.columns" :data="reviewsMainTable.data" :extHeight="0"
					:autoHeight="true" :loading="reviewsMainTable.loading" :table-search="reviewsMainTable.tableSearch"
					:table-load-event="reviewsMainTableRecords" />
				</Col>
			</Row>

		</div>
		<div>
			<Row :gutter="16">
				<Col span="24">
				<div class="global-tool-bar">
					<div class="left-bar">
						<span class="title">黑名单记录</span>
					</div>
				</div>
				</Col>
			</Row>
			<Row :gutter="16">
				<Col span="24">
				<stand-pagination-table
					:columns="blackRecordsTable.columns"
					:data="blackRecordsTable.data"
					:extHeight="0"
					:autoHeight="true"
					:loading="blackRecordsTable.loading"
					:table-search="blackRecordsTable.tableSearch"
					:table-load-event="getBlackRecordsList" />
				</Col>
			</Row>

		</div>
		<Modal v-model="updateReviewsShow" title="客户评价" :width="60" >
			<Form>
				<Row :gutter="24">
					<Col span="6">
					<FormItem label="会员号">
						<Input v-model="userExternalCustomerForm.userName" disabled></Input>
					</FormItem>
					</Col>
					<Col span="6">
					<FormItem label="会员姓名">
						<Input readonly v-model="userExternalCustomerForm.userExternalCustomerName" disabled></Input>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span="20">
					<FormItem label="评价">
						<Input v-model="reviewsForm.userReviewsText" type="textarea">
						</Input>
					</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="onReviewsSave">确认</Button>
				<Button type="error" @click="reviewsCancal()">取消</Button>
			</div>
		</Modal>
		<div slot="footer">
			<Button type="primary" @click="onSave" v-if="$checkAccessArray(['S', 'G'])">保存</Button>
			<Button type="error" @click="cancal()">取消</Button>
		</div>
	</Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat } from '@/libs/baseModelFormat';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { getDistributionStationList } from '@/api/modules/distributionStation-management/distributionStationList';
import { getBlackUserRecordsList } from '@/api/modules/operation-log/operation-log';
import {
    getUserReviewsList,
    deleteEreviews,
    saveEreviews,
    externalCustomerUserSave,
    getExternalCustomerUserDetail,
    pageInit4UserExternalCustomerEdit
} from '@/api/modules/account-management/externalCustomer-user-management';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import search from '@/libs/search';
import { OPERATION_TYPE } from '@/view/common/operation-log';
export default {
    name: 'ExternalCustomerUserEdit',
    components: {
        StandPaginationTable
    },
    data() {
        return {
            OPERATION_TYPE,
            selectedDistributionStationName: '',
            isBlacklisted: false,
            stationList: [],
            showDistribution: false,
            showFullAddress: false,
            showDescribe: false,
            show: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            postList: [
                {
                    value: '请申请人选择职务',
                    label: '请申请人选择职务'
                },
                {
                    value: '老板',
                    label: '老板'
                }, {
                    value: '负责人',
                    label: '负责人'
                }, {
                    value: '主管',
                    label: '主管'
                },
                {
                    value: '董事长',
                    label: '董事长'
                },
                {
                    value: '总经理',
                    label: '总经理'
                },
                {
                    value: '经理',
                    label: '经理'
                },
                {
                    value: '其他',
                    label: '其他'
                }
            ],
            unitList: [
                {
                    value: '平方米',
                    label: '平方米'
                },
                {
                    value: '亩',
                    label: '亩'
                }
            ],
            userExternalCustomerForm: {
                accountType: '',
                userExternalCustomerLoginUuid: '',
                userName: '',
                userExternalCustomerName: '',
                userExternalCustomerAreaUuid: '',
                userExternalCustomerContactNumber: '',
                userExternalCustomerPhone: '',
                userExternalCustomerDescribe: '',
                userExternalCustomerWechat: '',
                userExternalCustomerEmail: '',
                userExternalCustomerApproval: APPROVAL_YES,
                userExternalCustomerRelateCustomerManagerUuid: '',
                defaultCustomerManagerUuid: '',
                userExternalCustomerCompanyName: '',
                userExternalCustomerContact: '',
                userExternalCustomerProvinceUuid: '',
                userExternalCustomerCityUuid: '',
                userExternalCustomerDistUuid: '',
                userExternalCustomerFullAddress: '',
                userExternalCustomerPlanTime: '',
                userExternalCustomerCreateAt: '',
                post: '',
                unit: '',
                userExternalCustomerFarmName: '',
                userExternalCustomerGreenhouseArea: 0,
                userExternalCustomerReceiptFullAddress: '',
                userExternalCustomerProductionType: '',
                approvalFailReason: '',
                provinceOptions: [],
                cityOptions: [],
                distOptions: []

            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        message: '请输入会员号(大写"F"开头)',
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userExternalCustomerName: [
                    {
                        trigger: 'blur',
                        required: true,
                        message: '请输入申请人',
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 1 && value.length <= 200) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在1-200个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userExternalCustomerPhone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
                userExternalCustomerRelateCustomerManagerUuid: [
                    { required: true, message: '请选择客户经理', trigger: 'blur' }
                ],
                userExternalCustomerProvinceUuid: [
                    { required: true, message: '请选择省份', trigger: 'blur' }
                ],
                userExternalCustomerCityUuid: [
                    { required: true, message: '请选择城市', trigger: 'blur' }
                ],
                userExternalCustomerDistUuid: [
                    { required: true, message: '请选择区域', trigger: 'blur' }
                ],
                userExternalCustomerFullAddress: [
                    { required: true, message: '请输入花场地址', trigger: 'blur' }
                ]
            },
            password: '',
            passwordConfirm: '',
            areaSource: [],
            userCustomerManagerSource: [],
            accountTypeList: [
                "种苗种植户",
                "花店",
                "家庭园艺爱好者",
                "电商",
                "批发商",
                "其他"],
            approvalSource: [],
            regionSource: [],
            regionTop: '',
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            reviewsMainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '被评价人', key: 'userPersonName', width: 80, align: 'center' },
                    { title: '评价', key: 'userReviewsText', align: 'center' },
                    {
                        title: '评价人',
                        key: 'evaluatorPersonName',
                        width: 80, align: 'center',
                        render: (h, params) => {
                            let evaluatorPersonName = '';
                            if (this.personType == 'S' || this.personUserID == params.row.userReviewsEvaluatorUuid) {
                                evaluatorPersonName = params.row.evaluatorPersonName;
                            }

                            return h('div', evaluatorPersonName);
                        }
                    },
                    { title: '创建时间', key: 'userReviewsCreateAt', width: 120, align: 'center', render: (h, params) => dateTimeRender(h, params.row.userReviewsCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            const text = this.personUserID == params.row.userReviewsEvaluatorUuid ? '编辑' : '';
                            if (this.personUserID == params.row.userReviewsEvaluatorUuid) {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                        },
                                        on: {
                                            click: () => {
                                                this.onUpdateEreviews(params.row);
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                        },
                                        on: {
                                            click: () => {
                                                this.onDeleteEreviews(params.row);
                                            }
                                        }
                                    }, '删除')
                                ]);
                            }

                        }
                    }
                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },

            blackRecordsTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    {
                        title: '类型',
                        key: 'OperationType',
                        width: 80,
                        align: 'center',
                        render: (h, params) => {
                            const operationType = params.row.OperationType;
                            const foundItem = OPERATION_TYPE.find(item => item.value === operationType);
                            const label = foundItem && foundItem.label || '未知类型'; // 使用逻辑与和逻辑或替代可选链
                            return h('div', label);
                        }
                    },
                    { title: '详情', key: 'Meg', align: 'left' },
                    { title: '操作人', key: 'OperatorUsername', width: 120, align: 'center' },
                    {
                        title: '操作时间',
                        key: 'CreateTime',
                        width: 120,
                        align: 'center',
                        render:
						(h, params) => dateTimeRender(h, params.row.CreateTime) }
                ],
                data: [],
                loading: false,
                tableSearch: search.getSearchParams()
            },
            updateReviewsShow:false,
            reviewsForm: {
                editMode: '',
                userReviewsText:'',
                evaluatorUuid:'',
                userUuid:'',
                userReviewsUuid:''
            }
        };
    },
    watch: {
        'userExternalCustomerForm.userExternalCustomerProvinceUuid': function (newValue) {
            this.userExternalCustomerForm.userExternalCustomerCityUuid = '';
            this.cityOptions = this.regionSource.filter(r => r.regionParentUuid === newValue);
        },
        'userExternalCustomerForm.userExternalCustomerCityUuid': function (newValue) {
            this.userExternalCustomerForm.userExternalCustomerDistUuid = '';
            this.distOptions = this.regionSource.filter(r => r.regionParentUuid === newValue);
        }
    },
    computed: {
        personType() {
            return this.$store.state.user.personType;
        },
        personUserID() {
            return this.$store.state.user.userId;
        }

    },
    methods: {
        onSelectType(val) {
            if (val == 2) {
                this.showDistribution = true;
                this.showFullAddress = false;
            }
            else if (val == 1) {
                this.showDistribution = false;
                this.showFullAddress = false;
            }
            else {
                this.userExternalCustomerForm.userExternalCustomerReceiptFullAddress = "";
                this.showDistribution = false;
                this.showFullAddress = true;
            }
        },
        onShowReviewsChange(){
        },
        getBlackRecordsList(){
            ///获取黑名单记录
            this.blackRecordsTable.loading = true;
            search.globalAddFilterConditionKey(this.blackRecordsTable.tableSearch, "TargetID", "eq", this.accountUuid, true);
            getBlackUserRecordsList(this.blackRecordsTable.tableSearch).then(res => {
                if (res.code == 0) {
                    this.blackRecordsTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.blackRecordsTable.tableSearch, res.data.filterRecordCount);
                }
            });
            this.blackRecordsTable.loading = false;
        },
        reviewsMainTableRecords() {

            if (this.accountUuid) {

                let data = Object.assign({}, this.reviewsMainTable.tableSearch, { userUuid: this.accountUuid });
                getUserReviewsList(data).then(res => {
                    if (res.code == 0) {
                        this.reviewsMainTable.data = res.data.list;
                        search.globalSetFilterRecordCount(this.reviewsMainTable.tableSearch, res.data.total);
                    }
                });

            }

        },
        reviewsCancal(){
            this.updateReviewsShow=false;
        },
        onReviewsSave(){
            saveEreviews(this.reviewsForm).then(res=>{
                if(res.code==0){
                    this.$Message.info('保存成功');
                    this.updateReviewsShow=false;
                    this.reviewsMainTableRecords();
                }
            });
        },
        onUpdateEreviews(row){
            this.updateReviewsShow=true;
            this.reviewsForm.editMode=FORM_EDIT_MODE_MODIFY;
            this.reviewsForm.userReviewsUuid=row.userReviewsUuid;
            this.reviewsForm.userReviewsText=row.userReviewsText;
        },
        addEreviews(){
            this.updateReviewsShow=true;
            this.reviewsForm.editMode=FORM_EDIT_MODE_CREATE;
            this.reviewsForm.userUuid=this.userExternalCustomerForm.userExternalCustomerLoginUuid;
            this.reviewsForm.userReviewsText='';
            this.reviewsForm.evaluatorUuid=this.personUserID;
        },
        onDeleteEreviews(row) {
            this.$Modal.confirm({
                title: '确认删除这条记录',
                onOk: () => {
                    this.reviewsMainTable.loading = true;
                    deleteEreviews({ userReviewsUuid: row.userReviewsUuid }).then(res => {
                        this.reviewsMainTable.loading = false;
                        if (res.code == 0) {
                            this.$Message.info('删除成功');
                            this.reviewsMainTableRecords();
                        }
                        else {
                            this.$Modal.info({ title: '提示', content: res.message });
                        }
                    });
                }
            });


        },
        onshowDescribe(val) {
            if (val == 0) {
                this.showDescribe = true;
            }
            else {
                this.showDescribe = false;
            }
        },
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid, blackUser) {
            this.accountUuid = accountUuid;
            this.isBlacklisted = blackUser;
            this.show = true;
        },
        init() {
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });
            getDistributionStationList({}).then(res => {
                if (res.code === 0) {
                    if (res.data.stationList.length > 0) {
                        this.stationList = res.data.stationList;
                    }
                }
            });
            this.$showGlobalSpin();
            pageInit4UserExternalCustomerEdit().then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.areaSource = res.data.area.records.map(item => {
                        return {
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        };
                    });

                    this.userCustomerManagerSource = res.data.customerManager.records.filter(r => r.userCustomerManagerApproval === 1).map(item => {
                        return {
                            userCustomerManagerLoginUuid: item.userCustomerManagerLoginUuid,
                            userCustomerManagerName: item.userCustomerManagerName
                        };
                    });

                    this.regionSource = res.data.region.allRegions;
                    this.regionTop = res.data.region.topParentUuid;
                    this.provinceOptions = this.regionSource.filter(r => r.regionType === 1);

                    let orderList = ['云南', '广东', '山东', '辽宁', '江苏', '福建', '上海', '河南', '新疆', '四川', '北京', '浙江', '湖北', '海南', '安徽', '河北', '黑龙江', '陕西', '天津', '贵州', '甘肃', '吉林', '湖南', '山西', '宁夏', '江西', '重庆', '广西', '西藏', '内蒙古', '全国', '香港'];


                    const getIndex =provin=> {
					 let index=	orderList.findIndex(element => element === provin.regionName);
					 index=index>-1?index:999;
					 return index;
                    };
                    //排序
                    this.provinceOptions.sort((a, b) =>getIndex(a) - getIndex(b));
                    // const query = this.$route.query;
                    if (this.accountUuid) {
                        this.formEditMode = FORM_EDIT_MODE_MODIFY;

                        getExternalCustomerUserDetail(this.accountUuid).then(detail => {
                            if (detail.code === 0) {
                                const info = detail.data.userExternalCustomer;
                                this.userExternalCustomerForm = Object.assign(this.userExternalCustomerForm, info);
                                if (this.userExternalCustomerForm.memberDeliveryAddressSelectType == 2) {
                                    this.showDistribution = true;
                                    this.showFullAddress = false;
                                }
                                else if (this.userExternalCustomerForm.memberDeliveryAddressSelectType == 1) {
                                    this.showDistribution = false;
                                    this.showFullAddress = false;
                                }
                                else {
                                    this.showDistribution = false;
                                    this.showFullAddress = true;
                                }

                                if (info.userExternalCustomerApproval == 0) {
                                    this.showDescribe = true;
                                }

                                this.userExternalCustomerForm.userExternalCustomerProvinceUuid = info.userExternalCustomerProvinceUuid;
                                setTimeout(() => {
                                    this.userExternalCustomerForm.userExternalCustomerCityUuid = info.userExternalCustomerCityUuid;
                                }, 0);
                                this.userExternalCustomerForm.userExternalCustomerCityUuid = info.userExternalCustomerCityUuid;
                                setTimeout(() => {
                                    this.userExternalCustomerForm.userExternalCustomerDistUuid = info.userExternalCustomerDistUuid;
                                }, 0);
                            }
                        });
                    }
                    else {
                        this.$refs.userExternalCustomerForm.resetFields();
                    }
                }
            }).catch(() => {
                this.$hideGlobalSpin();
            });
            this.reviewsMainTableRecords();
            this.getBlackRecordsList();
        },
        onSave() {
            if (this.userExternalCustomerForm.userName == '') {
                this.$Message.error('会员号不能为空!');
                return;
            }
            if (this.userExternalCustomerForm.userExternalCustomerName == '') {
                this.$Message.error('申请人不能为空!');
                return;
            }
            if (this.userExternalCustomerForm.userExternalCustomerPhone == '') {
                this.$Message.error('手机号不能为空!');
                return;
            }
            if (this.userExternalCustomerForm.userExternalCustomerApproval == 1) {
                if (this.userExternalCustomerForm.userExternalCustomerRelateCustomerManagerUuid == '') {
                    this.$Message.error('客户经理不能为空!');
                    return;
                }
                if (this.userExternalCustomerForm.userExternalCustomerProvinceUuid == '') {
                    this.$Message.error('请选择花场所在地省份!');
                    return;
                }
                if (this.userExternalCustomerForm.userExternalCustomerCityUuid == '') {
                    this.$Message.error('请选择花场所在地城市!');
                    return;
                }
                if (this.userExternalCustomerForm.userExternalCustomerDistUuid == '') {
                    this.$Message.error('请选择花场所在地区域!');
                    return;
                }
                if (this.userExternalCustomerForm.userExternalCustomerFullAddress == '') {
                    this.$Message.error('请输入花场所在地详细地址!');
                    return;
                }
            }

            const data = Object.assign({ formEditMode: this.formEditMode }, this.userExternalCustomerForm);
            if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                data.password = this.password;
                data.passwordConfirm = this.passwordConfirm;
            }

            this.$showGlobalSpin();
            externalCustomerUserSave(data).then(res => {
                this.$hideGlobalSpin();
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.getExternalCustomerUserTableRecords();
                        }
                    });
                }
            });
        },
        cancal() {
            this.show = false;
            this.password = '';
            this.passwordConfirm = '';
            this.$parent.getExternalCustomerUserTableRecords();
        },
        CustomerCreateAt() {
            this.userExternalCustomerForm.userExternalCustomerCreateAt = new Date();
        },
        onChangeCustomerManager(){
            if (this.formEditMode === FORM_EDIT_MODE_CREATE)
                this.userExternalCustomerForm.defaultCustomerManagerUuid = this.userExternalCustomerForm.userExternalCustomerRelateCustomerManagerUuid;
        }
    }
};
</script>

<style scoped>
.ivu-radio-group-button .ivu-radio-wrapper {
	padding: 0px 10px;
}

.areaunit {
	display: flex;
}

.area {
	width: 110px;
}
</style>
